import './App.css';
import React, { useEffect } from 'react';
import {Reset} from 'styled-reset';
import {BrowserRouter as Router, Route, Routes, Navigate, useLocation} from 'react-router-dom';
import {ThemeProvider} from '@mui/material/styles';
import {theme} from './styles/theme';
// import {MenuProvider} from './components/MenuContext';
import {IsLoginProvider} from './components/IsLoginContext';
import { setupTokenInterceptor } from './commons/tokenUtils';

import LandingPage from "./landing";
import SignUp from './screens/login/signUp';

//admin_통합관리자
import GeneralManager from './screens/admin/adminLayout';
import OrgManagement from "./screens/admin/orgMng/orgManagement";
import MemberManagement from './screens/admin/memberMng/memberManagement';
import QrManagement from './screens/admin/qrMng/qrManagement';
import ScreenManagement from './screens/admin/screenMng/screenManagement';
import FacilityManagement from './screens/admin/facilityMng/facilityManagement';

// manager_관리자
import ManagerLayout from "./screens/manager/managerLayout";
import DashBoardFacility from "./screens/manager/dashBoard/dashBoardFacility";
import DashBoardPerson from "./screens/manager/dashBoard/dashBoardPerson";
import FacilityInfo from "./screens/manager/facilityInfo/facilityInfo";
import FcltyRgstr from "./screens/manager/facilityInfo/fcltyRgstr";
import FcltyRgstrEdt from "./screens/manager/facilityInfo/fcltyRgstrEdt";
import FacilityCheckStatus from "./screens/manager/checkStatus/facilityCheckStatus";
import CheckStatusSheet from "./screens/manager/checkStatus/facilitycheckStatusDetail";
import FacilityUncheckStatus from "./screens/manager/checkStatus/facilityUncheckStatus";
import CustomerVoice from "./screens/manager/customerVoice/customerVoice";
import AS from "./screens/manager/as/as";
import ShowOrg from "./screens/manager/org/showOrg";
import PersonalInfo from './screens/manager/personalInfo';
import RegularInspection from './screens/manager/bulletinBoard/regularInspection/regularInspection';
import GuidesArchive from './screens/manager/bulletinBoard/safetyGuide/guidesArchieve';
import Report from './screens/manager/report/report';

//checker_점검자
import CheckerLayout from './screens/checker/checkerLayout';
import CheckerSignUp from "./screens/checker/checkerSignUp";
import PersonalPage from './screens/checker/personal';
import ToRegisterList from './screens/checker/toRegisterList';
import RegisterCheck from './screens/checker/registerCheck';
import RegisteredList from './screens/checker/registeredList';
import RegisteredDetail from './screens/checker/registeredDetail';
import ImprovementRegistrationList from './screens/checker/improvementRegistrationList';
import ImprovementInfo from "./screens/checker/improvementInfo";
import ImprovementInfoRegistration from "./screens/checker/improvementInfoRegistration";
import ImprovementList from './screens/checker/improvementList';
import ImprovementRegistration from './screens/checker/improvementRegistration';

//complaints_민원인(일반 시민)
import ComplaintIntro from "./screens/complaints/complaintIntro";
import ComplaintInput from './screens/complaints/complaintInput';
import ComplaintCheckList from "./screens/complaints/complaintCheckList";
import ForceRegister from './screens/manager/forceRegister/forceRegister';

import SafetyIntro from './screens/checker/safety/safetyIntro';
import SafetyCheckForm from './screens/checker/safety/infoForm';
import SafetyGuide from './screens/checker/safety/safetyGuide';
import NotFound from './screens/checker/safety/notFoundPage';

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
        <Routes location={location}>
            <Route path="/" element={<LandingPage/>}/>
            {/* checker 관련 페이지 라우팅 */}
            <Route path="/checker/register-check/:facilityId" element={<RegisterCheck/>}/>
            <Route path="/checker/registered-detail/:id" element={<RegisteredDetail/>}/>
            <Route path="/checker/improvement-registration/:id" element={<ImprovementRegistration/>}/>
            <Route path="/checker/sign-up" element={<CheckerSignUp/>}/>
            <Route path="/checker/improvement-info/:id" element={<ImprovementInfo/>}/>
            <Route path="/checker/improvement-info-registration/:id" element={<ImprovementInfoRegistration/>}/>
            <Route path="/checker/personal" element={<PersonalPage/>}/>
            <Route path="/checker" element={<CheckerLayout/>}>
                <Route index element={<Navigate to="/checker/to-register-list" replace/>}/>
                <Route path="to-register-list" element={<ToRegisterList/>}/>
                <Route path="registered-list" element={<RegisteredList/>}/>
                <Route path="improvement-registration-list" element={<ImprovementRegistrationList/>}/>
                <Route path="improvement-list" element={<ImprovementList/>}/>
            </Route>
            {/* 민원인 관련 페이지 라우팅 */}
            <Route path="/complaint/:facilityId" element={<ComplaintIntro/>}/>
            <Route path="/complaint-input/:facilityId" element={<ComplaintInput/>}/>
            <Route path="/complaint-check-list/:facilityId" element={<ComplaintCheckList/>}/>
            {/* 안전수칙 페이지 */}
            <Route path="/safetyIntro/:noticeId" element={<SafetyIntro/>}/>
            <Route path="/safetyInfro" element={<NotFound />} />
            <Route path="/safetyCheckForm/:noticeId" element={<SafetyCheckForm/>}/>
            <Route path="/safetyCheckForm" element={<NotFound />} />
            <Route path="/safetyGuide/:noticeId" element={<SafetyGuide/>}/>
            {/* admin 관련 페이지 라우팅 */}
            <Route path="/admin" element={<GeneralManager/>}>
                {/*<Route index element={<Navigate to="/admin/org-management" replace/>}/>*/}
                <Route index element={<Navigate to="/admin/member-management" replace/>}/>
                <Route path="org-management" element={<OrgManagement/>}/>
                <Route path="member-management" element={<MemberManagement/>}/>
                <Route path="qr-management" element={<QrManagement/>}/>
                <Route path="screen-management" element={<ScreenManagement/>}/>
                <Route path="facility-management" element={<FacilityManagement/>}/>
            </Route>
            <Route path="/improvementRegistration" element={<ImprovementRegistration/>}/>
            <Route path="/sign-up" element={<SignUp/>}/>
            {/* manager 재구성 페이지 라우팅 */}
            <Route path="/manager" element={<ManagerLayout/>}>
                <Route index element={<Navigate to="/manager/dashboard/facility" replace/>}/>
                <Route path="dashboard/facility" element={<DashBoardFacility/>}/>
                <Route path="dashboard/person" element={<DashBoardPerson/>}/>
                <Route path="facility-info" element={<FacilityInfo/>}/>
                <Route path="facility-registration" element={<FcltyRgstr/>}/>
                <Route path="facility-registration-edit/:facilityId" element={<FcltyRgstrEdt/>}/>
                <Route path="status/check" element={<FacilityCheckStatus/>}/>
                <Route path="status/check/sheet/:facilityId" element={<CheckStatusSheet/>}/>
                <Route path="status/uncheck" element={<FacilityUncheckStatus/>}/>
                <Route path="customer-voice" element={<CustomerVoice/>}/>
                <Route path="as" element={<AS/>}/>
                <Route path="report" element={<Report/>}/>
                <Route path="bulletin-board/regularInspection" element={<RegularInspection/>}/>
                <Route path="bulletin-board/guides" element={<GuidesArchive/>}/>
                <Route path="showOrg" element={<ShowOrg/>}/>
                <Route path="force-register" element={<ForceRegister/>}/>
            </Route>
            <Route path="/manager" >
                <Route path="personal-info" element={<PersonalInfo/>}/>
            </Route>
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

function App() {
    useEffect(() => {
        // 앱 시작 시 토큰 인터셉터 설정
        try {
            setupTokenInterceptor();
            console.log('토큰 인터셉터 설정 완료');
        } catch (error) {
            console.error('토큰 인터셉터 설정 중 오류 발생:', error);
        }

        // 앱 시작 시 토큰 상태 로깅 (디버깅용)
        const accessToken = localStorage.getItem('access_token');
        const refreshToken = localStorage.getItem('refresh_token');

        if (accessToken && refreshToken) {
            console.log('기존 토큰 감지됨 - 자동 인증 처리 준비');
        } else {
            console.log('저장된 토큰 없음 - 로그인 필요');
        }

        // iOS PWA alert 문제 해결을 위한 alert 오버라이드 (수정된 버전)
        const originalAlert = window.alert;

        window.alert = function(message) {
            // iOS PWA 모드 감지 (아이폰에서 홈화면 추가된 경우)
            if (window.navigator.standalone === true) {
                // iOS에서 스크롤 방지를 위한 변수
                const originalOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';

                // 배경 오버레이 생성
                const overlay = document.createElement('div');
                overlay.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.6);
            z-index: 99999;
            display: flex;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            padding: 20px;
            box-sizing: border-box;
        `;

                // 알림 모달 생성
                const alertModal = document.createElement('div');
                alertModal.style.cssText = `
            background: white;
            border-radius: 20px;
            padding: 28px 24px 24px 24px;
            max-width: 320px;
            min-width: 280px;
            width: calc(100vw - 80px);
            text-align: center;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
            border: 1px solid rgba(0, 0, 0, 0.1);
        `;

                // 메시지 텍스트
                const messageText = document.createElement('div');
                messageText.style.cssText = `
            font-size: 17px;
            line-height: 1.47;
            color: #1d1d1f;
            margin-bottom: 24px;
            font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;
            font-weight: 400;
            word-break: keep-all;
            white-space: pre-wrap;
        `;
                messageText.textContent = message;

                // 확인 버튼
                const confirmButton = document.createElement('button');
                confirmButton.style.cssText = `
            background: var(--main-blue-color);
            color: white;
            border: none;
            border-radius: 12px;
            padding: 14px 28px;
            font-size: 17px;
            font-weight: 600;
            cursor: pointer;
            min-width: 100px;
            font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;
            outline: none;
            -webkit-tap-highlight-color: transparent;
        `;
                confirmButton.textContent = '확인';

                // 모달 닫기 함수
                const closeModal = function() {
                    if (overlay.parentNode) {
                        overlay.parentNode.removeChild(overlay);
                    }
                    // 스크롤 복원
                    document.body.style.overflow = originalOverflow;
                };

                // 버튼 터치 효과
                confirmButton.addEventListener('touchstart', function(e) {
                    e.preventDefault();
                    this.style.opacity = '0.7';
                });

                confirmButton.addEventListener('touchend', function(e) {
                    e.preventDefault();
                    this.style.opacity = '1';
                    setTimeout(() => closeModal(), 100);
                });

                confirmButton.addEventListener('touchcancel', function() {
                    this.style.opacity = '1';
                });

                // 마우스 이벤트 (데스크톱용)
                confirmButton.addEventListener('mousedown', function() {
                    this.style.opacity = '0.7';
                });

                confirmButton.addEventListener('mouseup', function() {
                    this.style.opacity = '1';
                });

                confirmButton.addEventListener('mouseleave', function() {
                    this.style.opacity = '1';
                });

                // 이벤트 리스너
                confirmButton.addEventListener('click', closeModal);

                // DOM에 추가
                alertModal.appendChild(messageText);
                alertModal.appendChild(confirmButton);
                overlay.appendChild(alertModal);
                document.body.appendChild(overlay);

                // 버튼에 포커스 (키보드 접근성)
                setTimeout(() => confirmButton.focus(), 100);

            } else {
                // 안드로이드, PC, 일반 브라우저에서는 기존 alert 사용
                originalAlert(message);
            }
        };
    }, []);

    return (
        <IsLoginProvider>
            <Reset/>
            <ThemeProvider theme={theme}>
                <Router>
                    <AnimatedRoutes/>
                </Router>
            </ThemeProvider>
        </IsLoginProvider>
    );
}

export default App;